module.exports = __webpack_public_path__ + "static/img/govcard_white_10.24ecbad3.svg";